export default function stickySidebar () {
	(function () {
		const sideNav = document.querySelector('#side-navigation');
		const bsSideNav = document.querySelector('.bs-sidenav');

		// check if it's IE11
		function getIEVersion() {
			let sAgent = window.navigator.userAgent;
			let Idx = sAgent.indexOf('MSIE');
			// If IE, return version number.
			if (Idx > 0)
				return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf('.', Idx)));
			// If IE 11 then look for Updated user agent string.
			else if (navigator.userAgent.match(/Trident\/7\./))
				return 11;
			else
				return 0; // It is not IE
		}
		if(bsSideNav) {
			if (sideNav) {
				const sideNavChild = sideNav.children[0];
				if (getIEVersion() > 0) {
					sideNavChild.classList.add('bs-sidebar');
					sideNav.style.display = 'block';
					sideNav.style.top = '0';
				}
			}

			// hide sideNav if it is empty
			if(bsSideNav.children.length === 0) {
				sideNav.classList.add('side-navigation--hidden');
			}
		}
	})();
}
